webpackJsonp([198101643931764],{

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookBindActions = __webpack_require__(62);
	
	var _LoreHookBindActions2 = _interopRequireDefault(_LoreHookBindActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookBindActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In Lore, invoking action creators is as simple as something like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      lore.actions.tweet.create({\n        text: \'Message to tweet\'\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This call invokes the action creator, makes an AJAX calls, and dispatches the result to the Redux Store. But if you look at the signature for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'create'
	      ),
	      ' action, you may wonder where the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch'
	      ),
	      ' argument comes from:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = function create(params) {\n        return function(dispatch) {\n          // ...code for the action creator...\n        };\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you read the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://redux.js.org/docs/api/bindActionCreators.html' },
	        'Redux docs for bindActionCreators'
	      ),
	      ' you\'ll notice that action creators are not normally bound to the Redux store. They\'re "pure" in the sense that they\'re just a function with some arguments. The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bindActionCreators'
	      ),
	      ' method is what actually takes the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch'
	      ),
	      ' method from the Redux store and binds it to the action creator, so it can dispatch messages to the Store.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook iterates through all actions and binds them to the Redux store. This means instead of having to write code like this all over your application:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { bindActionCreators } from \'redux\'\n\n      let createAction = bindActionCreators(\n        lore.actions.tweet.create,\n        lore.store.dispatch\n      );\n\n      createAction({\n        text: \'Message to tweet\'\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can simply write this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      lore.actions.tweet.create({\n        text: \'Message to tweet\'\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-bind-actions-usage-index-js-953dace423312d28682a.js